var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","absolute":"","scroll-target":"#home","elevate-on-scroll":"","dark":"","color":"primary"}},[_c('v-container',[_c('h1',{staticClass:"text-button text-center"},[_vm._v("LUBRICANTES ALONSO")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }